import React from 'react';
import { Modal, Icon, Form, Select, Row, Col, Card, Timeline, Button } from 'antd';

const { Option } = Select;

class FormModal extends React.Component {
    constructor(props) {
        super(props);

    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {

        var url = 'https://api.whatsapp.com/send?phone=51922636112&text=Hola me podrias dar mas informacion del sistema de facturacion'
        var message = '';
        window.open(url, "_blank", "noreferrer");

    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Modal
                title={"PLANES ACSOFT ERP"}
                visible={this.props.visible}
                style={{ top: 30 }}
                onCancel={(properties) => { this.handleCancel() }}
                width="1200px"
                footer={[
                    <Button key="cancel" onClick={this.handleCancel}>
                        Cerrar
                    </Button>

                ]}

            >

                <Row gutter={[16, 16]}>
                    <Col sm={24} md={6} >
                        <div>
                            <Card
                                bordered
                                style={{ display: 'block', padding: '0px', borderRadius: '10px' }}
                                headStyle={{ padding: '0px' }}
                                title={
                                    <div
                                        style={{ textAlign: 'center', color: 'white' }}
                                    >
                                        <div style={{ backgroundColor: '#1890ff', borderRadius: '10px' }} >
                                            <br />
                                            <span style={{ fontWeight: '900' }}> APP ACSOFT ERP</span>
                                            <p>Plan Básico desde</p>

                                            <div style={{ backgroundColor: '#34c724' }}>
                                                <strong>s/</strong><span style={{ fontWeight: 'bold', fontSize: '40px' }}>  49.00</span> <strong>/ mes</strong>
                                                <p>15% Desct. pago anual</p>
                                            </div>
                                        </div>
                                    </div>
                                }

                            >
                                <Timeline>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">1 Licencia (Sistema)</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">2 Usuarios Internos</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Hasta 50 Comprobantes / mes</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Hasta 500 Productos</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">1 Establecimiento</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">1 Almacén</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Facturación Electrónica</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Ventas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Registro de Ventas (PLE)</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Consulta automática RUC / DNI</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Certificado Digital Incluido</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">CPE envío a SUNAT</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green"> Web Service Consulta CPE</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">App Móvil en Android</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Soporte 8hx5d</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Guía de Remisión Remitente</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Guía de Remisión Transportista</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">SIRE Ventas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Comprobantes envÍo a OSE</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Acceso ACSOFT ERP Web</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Soporte Personalizado</Timeline.Item>

                                </Timeline>
                                <Button
                                    type="primary"
                                    block
                                    role='link'
                                    onClick={() => this.handleOk("PYME")}
                                >
                                    Contactar con Asesor
                                </Button>
                            </Card>
                        </div>
                    </Col>
                    <Col sm={24} md={6} >
                        <div>
                            <Card
                                bordered
                                style={{ display: 'block', padding: '0px', borderRadius: '10px' }}
                                headStyle={{ padding: '0px' }}
                                title={
                                    <div
                                        style={{ textAlign: 'center', color: 'white' }}
                                    >
                                        <div style={{ backgroundColor: '#1890ff', borderRadius: '10px' }} >
                                            <br />
                                            <span style={{ fontWeight: '900' }}>ACSOFT ERP EMPRENDEDOR</span>
                                            <p>Plan Básico desde</p>

                                            <div style={{ backgroundColor: '#34c724' }}>
                                                <strong>s/</strong><span style={{ fontWeight: 'bold', fontSize: '40px' }}>  59.00</span> <strong>/ mes</strong>
                                                <p>15% Desct. pago anual</p>

                                            </div>
                                        </div>
                                    </div>
                                }

                            >
                                <Timeline>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">1 Licencia (Sistema)</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">5 Usuarios Internos</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Hasta 200 Comprobantes / mes</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Hasta 1000 Productos</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">2 Establecimientos</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">2 Almacenes</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Facturación Electrónica</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Ventas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Administración</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Seguridad</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Registro de Ventas (PLE)</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">SIRE Ventas</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Consulta automática RUC / DNI</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Certificado Digital Incluido</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">CPE envío a SUNAT</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Web Service Consulta CPE</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Soporte 8hx5d</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Plataforma ACSOFT ERP Web</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Guía de Remisión Remitente</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Guía de Remisión Transportista</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Comprobantes envÍo a OSE</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Acceso App Móvil Ventas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Soporte Personalizado</Timeline.Item>
                                </Timeline>
                                <Button
                                    type="primary"
                                    block
                                    role='link'
                                    onClick={() => this.handleOk("PYME")}
                                >
                                    Contactar con Asesor
                                </Button>
                            </Card>
                        </div>
                    </Col>
                    <Col sm={24} md={6} >
                        <div>
                            <Card
                                bordered
                                style={{ display: 'block', padding: '0px', borderRadius: '10px' }}
                                headStyle={{ padding: '0px' }}
                                title={
                                    <div
                                        style={{ textAlign: 'center', color: 'white' }}
                                    >
                                        <div style={{ backgroundColor: '#1890ff', borderRadius: '10px' }} >
                                            <br />
                                            <span style={{ fontWeight: '900' }}> ACSOFT ERP MYPE</span>
                                            <p>Plan Básico desde</p>

                                            <div style={{ backgroundColor: '#34c724' }}>
                                                <strong>s/</strong><span style={{ fontWeight: 'bold', fontSize: '40px' }}>  79.00</span> <strong>/ mes</strong>
                                                <p>15% Desct. pago anual</p>

                                            </div>
                                        </div>
                                    </div>
                                }

                            >
                                <Timeline>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">2 Licencia (Sistema)</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">10 Usuarios Internos</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Hasta 300 Comprobantes / mes</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Hasta 1500 Productos</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Establecimientos Ilimitados</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Almacenes Ilimitados</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Facturación Electrónica</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Ventas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Logistica</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Administración</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Seguridad</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Registro de Compras (PLE)</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Registro de Ventas (PLE)</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">SIRE Ventas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Kardex Valorizado</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Consulta automática RUC / DNI</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Certificado Digital Incluido</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Comprobantes envío a SUNAT</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green"> Web Service Consulta CPE</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Soporte Técnico 8hx5d</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Acceso ACSOFT ERP Web</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Guía de Remisión Remitente</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Guía de Remisión Transportista</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Inventario Valorizado</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Conversión de Medidas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Módulo Reporte Gerencial</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Acceso App Móvil Ventas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Soporte Personalizado</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Comprobantes envÍo a OSE</Timeline.Item>


                                </Timeline>
                                <Button
                                    type="primary"
                                    block
                                    role='link'
                                    onClick={() => this.handleOk("PYME")}
                                >
                                    Contactar con Asesor
                                </Button>
                            </Card>
                        </div>
                    </Col>
                    <Col sm={24} md={6} >
                        <div>
                            <Card
                                bordered
                                style={{ display: 'block', padding: '0px', borderRadius: '10px' }}
                                headStyle={{ padding: '0px' }}
                                title={
                                    <div
                                        style={{ textAlign: 'center', color: 'white' }}
                                    >
                                        <div style={{ backgroundColor: '#1890ff', borderRadius: '10px' }} >
                                            <br />
                                            <span style={{ fontWeight: '900' }}> ACSOFT ERP PYME</span>
                                            <p>Plan Básico desde</p>

                                            <div style={{ backgroundColor: '#34c724' }}>
                                                <strong>s/</strong><span style={{ fontWeight: 'bold', fontSize: '40px' }}>  109.00</span> <strong>/ mes</strong>
                                                <p>15% Desct. pago anual</p>

                                            </div>
                                        </div>
                                    </div>
                                }

                            >
                                <Timeline>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">2 Licencia (Sistema)</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Usuarios Internos Ilimitados</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Hasta 500 Comprobantes / mes</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Hasta 2500 Productos</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Establecimientos Ilimitados</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Almacenes Ilimitados</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Facturación Electrónica</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Ventas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Logistica</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Cobranza</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Crédito y Cobranzas</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Administración</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo Reporte Gerencial</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Módulo de Seguridad</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Registro de Compras (PLE)</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Registro de Ventas (PLE)</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">SIRE Ventas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Kardex Valorizado</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Consulta automática RUC / DNI</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Certificado Digital Incluido</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Comprobantes envío a SUNAT</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Web Service Consulta CPE</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Soporte  8hx6d</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green">Acceso ACSOFT ERP Web</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Conversión de Medidas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Acceso App Móvil Ventas</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Soporte Personalizado</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Comprobantes envÍo a OSE</Timeline.Item>

                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Módulo Proyectos</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Módulo Producción</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Módulo Importaciónes</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Módulo Recursos Humanos</Timeline.Item>
                                    <Timeline.Item dot={<Icon type="close-circle" style={{ fontSize: '16px' }} />} color="red">Módulo Contabilidad</Timeline.Item>



                                </Timeline>
                                <Button
                                    type="primary"
                                    block
                                    role='link'
                                    onClick={() => this.handleOk("PYME")}
                                >
                                    Contactar con Asesor
                                </Button>
                            </Card>
                        </div>
                    </Col>

                </Row>


            </Modal>
        );
    }
}
export default Form.create()(FormModal)